// src/components/ModalMotoristaChegou.js
import React from "react";

export default function ModalMotoristaChegou({ motoristaNome, placa, onFechar }) {
  return (
    <div style={{
      position: "fixed", inset: 0, zIndex: 99990,
      background: "rgba(0,0,0,0.75)",
      display: "flex", alignItems: "flex-end",
      fontFamily: "'Segoe UI', system-ui, sans-serif",
    }}>
      <style>{`@keyframes pulse{0%,100%{opacity:1}50%{opacity:0.6}} @keyframes slideUp{from{opacity:0;transform:translateY(100%)}to{opacity:1;transform:translateY(0)}}`}</style>
      <div style={{
        width: "100%", maxWidth: 480, margin: "0 auto",
        background: "#0d1527",
        borderRadius: "24px 24px 0 0",
        padding: "24px 24px 44px",
        border: "1px solid rgba(245,158,11,0.3)",
        borderBottom: "none",
        animation: "slideUp 0.35s ease",
      }}>
        <div style={{ width: 36, height: 4, background: "rgba(255,255,255,0.15)", borderRadius: 2, margin: "0 auto 20px" }} />

        <div style={{ textAlign: "center", marginBottom: 20 }}>
          <div style={{
            width: 72, height: 72, borderRadius: "50%",
            background: "rgba(245,158,11,0.12)",
            border: "2px solid #f59e0b",
            display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: 32, margin: "0 auto 14px",
            animation: "pulse 1.5s ease-in-out infinite",
          }}>
            📍
          </div>
          <p style={{ color: "#f59e0b", fontWeight: 800, fontSize: 20, margin: "0 0 6px" }}>
            Seu motorista chegou!
          </p>
          <p style={{ color: "rgba(255,255,255,0.5)", fontSize: 14, margin: 0 }}>
            {motoristaNome} está te esperando agora
          </p>
        </div>

        {placa && (
          <div style={{
            background: "rgba(245,158,11,0.07)",
            border: "1px solid rgba(245,158,11,0.2)",
            borderRadius: 14,
            padding: "14px 18px",
            textAlign: "center",
            marginBottom: 20,
          }}>
            <p style={{ color: "rgba(255,255,255,0.35)", fontSize: 11, letterSpacing: 1, margin: "0 0 6px", textTransform: "uppercase" }}>
              Procure o veículo com a placa
            </p>
            <p style={{ color: "#fff", fontSize: 26, fontWeight: 800, margin: 0, letterSpacing: 4 }}>
              {placa}
            </p>
          </div>
        )}

        <button
          onClick={onFechar}
          style={{
            width: "100%", padding: "15px",
            borderRadius: 14, border: "none",
            background: "linear-gradient(135deg,#f59e0b,#d97706)",
            color: "#fff", fontSize: 15, fontWeight: 800,
            cursor: "pointer", fontFamily: "inherit",
            boxShadow: "0 4px 20px rgba(245,158,11,0.4)",
          }}
        >
          Ok, estou indo! 🚶
        </button>
      </div>
    </div>
  );
}